<template>
  <v-app data-app class="customer-app" id="app">
    <!-- <router-view></router-view> -->
    <v-main>
      <SingleCard
        @readyToUpdate="updateScreen('single')"
        @forwardAnswerToAppForBackendProcessing="processAnswerInBackend($event)"
        @forwardMultipleAnswerToAppForBackendProcessing="
          processMultipleAnswerInBackend($event)
        "
        @showFeatureUnavailableModal="showFeatureUnavailableModal($event)"
        @reportNewTopicModal="reportNewTopicModal()"
        @showLoadingModal="showLoadingModal($event)"
        ref="single"
        v-if="screenToDisplay === 'single'"
      />
      <MultiCards
        @readyToUpdate="updateScreen('multi')"
        @forwardAnswerToAppForBackendProcessing="processAnswerInBackend($event)"
        @addToBasket="addToBasket($event)"
        ref="multi"
        :basketData="basketData"
        v-if="screenToDisplay === 'multi'"
      />
      <ConsultationOverview
        ref="consult-overview"
        @forwardAnswerToAppForBackendProcessing="processAnswerInBackend($event)"
        @removeItemFromBasket="removeFromBasket($event)"
        :productData="productData"
        v-if="screenToDisplay === 'consult-overview'"
      />
      <TopicSelection
        ref="topic-selection"
        @readyToUpdate="updateScreen('topic-selection')"
        @forwardAnswerToAppForBackendProcessing="processAnswerInBackend($event)"
        @reportNewTopicModal="reportNewTopicModal()"
        @showFeatureUnavailableModal="showFeatureUnavailableModal($event)"
        v-if="screenToDisplay === 'topic-selection'"
      />
    </v-main>

    <!-- cart drawer  -s -->
    <cart-drawer v-model="drawer">
      <template #cart_title> Merkliste </template>
      <template #cart_description>
        Hier finden Sie alle Hilfsmittel, die Sie auf die Merkliste gesetzt
        haben. Im nächsten Schritt können Sie einen Anbieter finden, von dem Sie
        die Hilfsmittel erhalten können.
      </template>
      <template #cart_btn_txt> Anbieter finden </template>
    </cart-drawer>
    <!-- cart drawer  -e -->
    <!-- modal  -->
    <v-dialog v-model="modal" width="777px">
      <v-card class="dialog-card">
        <div class="body">
          <img class="quote-top" alt="anni logo" src="../assets/quotes.svg" />
          <div class="text-semibold">
            Super. Ich habe mir das Produkt für Sie gemerkt.
          </div>
          <div class="text-regular">
            Alle gemerkten Produkte finden Sie dann am Ende der Beratung wieder.
          </div>
          <img
            class="quote-bottom"
            alt="anni logo"
            src="../assets/quotes.svg"
          />
        </div>

        <v-card-actions>
          <v-btn
            color="primary"
            class="primary-txt-btn"
            text
            @click="modal = false"
            >Weiter mit der Beratung</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- bug report modal -->
    <v-dialog
      v-model="bugreport"
      width="777px"
      content-class="feedback-modal"
      scrollable
    >
      <v-card class="dialog-card">
        <!-- <v-card-title></v-card-title> -->
        <v-card-text>
          <div class="body">
            <img class="quote-top" alt="anni logo" src="../assets/quotes.svg" />
            <div class="text-semibold">Lief etwas nicht so wie erwartet?</div>
            <div class="text-regular">
              Geben Sie einfach kurz ein, was nicht geklappt hat oder was Sie
              anders erwartet hätten.
              <v-textarea
                v-model="bugreportUserInput"
                placeholder="Beispiel: ANNI hat das falsche Produkt vorgeschlagen. Mit meinen Angaben würde ich erwarten, dass Produkt ABC vorgeschlagen wird."
              ></v-textarea>
            </div>
            <img
              class="quote-bottom"
              alt="anni logo"
              src="../assets/quotes.svg"
            />
          </div>

          <v-card-actions>
            <v-btn
              color="primary"
              class="primary-txt-btn"
              text
              @click="reportBug"
              >Feedback senden</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- support modal -->
    <v-dialog v-model="support" width="777px">
      <v-card class="dialog-card">
        <div class="body">
          <img class="quote-top" alt="anni logo" src="../assets/quotes.svg" />
          <div class="text-semibold">Können wir Ihnen weiterhelfen?</div>
          <div class="text-regular">
            Wenn Sie während der Beratung Fragen haben, rufen Sie gerne an. Das
            Team hinter ANNI freut sich, Ihnen behilflich zu sein.
            <br />
            <br />Telefon:
            <b>030 5200 1258</b>
            <br />
            <br />Sie erreichen uns von Montag bis Freitag von 9 Uhr bis 18 Uhr.
          </div>
          <img
            class="quote-bottom"
            alt="anni logo"
            src="../assets/quotes.svg"
          />
        </div>

        <v-card-actions>
          <v-btn
            color="primary"
            class="primary-txt-btn"
            text
            @click="support = false"
            >Zurück zur Beratung</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- non available feature modal -->
    <v-dialog v-model="nonavailfeature" width="777px">
      <v-card class="dialog-card">
        <div class="body">
          <img class="quote-top" alt="anni logo" src="../assets/quotes.svg" />
          <div class="text-semibold">
            Zu diesem Thema kann ich leider noch nicht beraten.
          </div>
          <div class="text-regular">
            Folgende Themen sind aktuell verfügbar:
            <br />
            <ul>
              <li>
                Hilfsmittel bei
                <b>eingeschränkter Bewegung</b>
              </li>
              <li>
                Hilfsmittel bei
                <b>Inkontinenz</b>
              </li>
              <li>
                Hilfsmittel für das
                <b>Badezimmer</b>
              </li>
            </ul>
            <br />Geben Sie Ihre E-Mail Adresse ein, und drücken Sie auf
            <b>Newsletter abonnieren</b>, um informiert zu bleiben.
            <v-text-field
              single-line
              v-model="newsletterEmail"
              placeholder="E-Mail Adresse"
            ></v-text-field>
          </div>
          <img
            class="quote-bottom"
            alt="anni logo"
            src="../assets/quotes.svg"
          />
        </div>

        <v-card-actions>
          <v-btn
            color="primary"
            depressed
            class="primary-txt-btn __h68"
            text
            @click="subscribeToNewsletter()"
            :disabled="!isValidMail()"
            >Newsletter abonnieren</v-btn
          >
          <v-btn
            color="grey"
            class="grey-txt-btn __h68"
            text
            @click="nonavailfeature = false"
            >zurück zur Beratung</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- report new topic modal -->
    <v-dialog v-model="reportnewtopic" width="777px">
      <v-card class="dialog-card">
        <div class="body">
          <img class="quote-top" alt="anni logo" src="../assets/quotes.svg" />
          <div class="text-semibold">Jetzt bin ich gespannt.</div>
          <div class="text-regular">
            Geben Sie Ihre Themen-Wünsche einfach ein. Das Team hinter ANNI
            freut sich über Ihre Ideen!
            <v-textarea
              v-model="newtopicUserInput"
              placeholder="Beispiel: ANNI soll zu Thema ABC beraten..."
            ></v-textarea>
          </div>
          <img
            class="quote-bottom"
            alt="anni logo"
            src="../assets/quotes.svg"
          />
        </div>

        <v-card-actions>
          <v-btn
            color="primary"
            class="primary-txt-btn"
            text
            @click="reportTopic"
            >Ideen ans anni.care-Team senden</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- loading modal -->
    <v-dialog v-model="loadingModal.visible" width="777px">
      <v-card class="dialog-card">
        <div class="body">
          <div class="text-semibold">{{ loadingModal.header }}</div>
          <div class="loading-circular">
            <v-progress-circular
              :size="100"
              :width="9"
              color="#35887E"
              indeterminate
            ></v-progress-circular>
          </div>
          <div class="text-regular">{{ loadingModal.subtitle }}</div>
        </div>
      </v-card>
    </v-dialog>

    <!-- mobile not optimized modal -->
    <v-dialog v-model="isMobileDevice" width="90%">
      <v-card class="dialog-card">
        <div class="body">
          <img class="quote-top" alt="anni logo" src="../assets/quotes.svg" />
          <div class="text-semibold">
            ANNI ist leider noch nicht für kleine Bildschirme optimiert.
          </div>
          <div class="text-regular">
            Bitte nutzen Sie für eine optimale Beratung einen Computer oder ein
            Tablet.
          </div>
          <img
            class="quote-bottom"
            alt="anni logo"
            src="../assets/quotes.svg"
          />
        </div>

        <v-card-actions>
          <v-btn
            color="primary"
            class="primary-txt-btn"
            text
            @click="isMobileDevice = false"
            >Okay</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import SingleCard from "../screens/SingleCard.vue";
import MultiCards from "../screens/MultiCards.vue";
import ConsultationOverview from "../screens/ConsultationOverview.vue";
import TopicSelection from "../screens/TopicSelection.vue";
import Vue from "vue";
import CartDrawer from "../components/LandingPage/CartDrawer.vue";

import {
  evaluateAnswer,
  reportBugToBackend,
  reportNewTopicToBackend,
  addMailToNewsletter,
  recordInterestInTopic,
} from "../services/MainService.js";

Vue.config.errorHandler = (err, vm, info) => {
  if (
    process.env.VUE_APP_DISABLE_CONSOLE_LOGS !== true ||
    process.env.VUE_APP_DISABLE_CONSOLE_LOGS !== "true"
  ) {
    console.log("Error: ", err, vm.name, info);
  }
};

Vue.config.warnHandler = function (err, vm, info) {
  if (
    process.env.VUE_APP_DISABLE_CONSOLE_LOGS !== true ||
    process.env.VUE_APP_DISABLE_CONSOLE_LOGS !== "true"
  ) {
    console.log("Warn", err, vm.name, info);
  }
};

// TODO => merge all configurations later in 1 config file
const SystemActionToScreenMapping = {
  TitleAndSubtitleWithCategorySelect: "multi",
  TitleAndSubtitleWith2Buttons: "single",
  TitleAndSubtitleWithTextbox: "single",
  TitleAndSubtitleWithCheckboxContainers: "single",
  TitleAndSubtitleWithChips: "single",
  TitleAndSubtitleWithProcessOverview: "single",
  TitleAndSubtitleWithCheckmarkBox: "single",
  TitleAndSubtitleWithContactDetails: "single",
  TitleAndSubtitleWithContactDetailsExtended: "single",
  TitleAndSubtitleWithDropDown: "single",
  TitleAndSubtitleWithSignature: "single",
  TitleAndSubtitleNothingElse: "single",
  ConsultationOverview: "consult-overview",
  TopicSelection: "topic-selection",
};

export default {
  components: {
    SingleCard,
    MultiCards,
    ConsultationOverview,
    TopicSelection,
    CartDrawer,
  },
  data() {
    return {
      originalFlowState: {},
      flowStateHistory: [],
      executedSystemAction: {},
      meta: {}, // meta data from backend to keep while state passing
      productData: {}, // product data from backend
      modal: null,
      bugreport: null,
      support: null,
      nonavailfeature: null,
      reportnewtopic: null,
      loadingModal: {
        visible: false,
        header: "",
        subtitle: "",
      },
      bugreportUserInput: "",
      newtopicUserInput: "",
      drawer: null,
      screenToDisplay: "topic-selection",
      newsletterEmail: "",
      validationRules: [
        (input) =>
          this.isValidMail(input) ||
          "Bitte geben Sie eine gültige E-Mail Adresse ein!",
      ],
      selectedUnavailableFeature: null, // is set when user selects unavailable topic in order to report to backend
      isMobileDevice: null,
    };
  },
  methods: {
    processAnswerInBackend(data, multipleAnswers) {
      let outputFlowObject = {};

      // if multiple answers are given, data is an array
      if (multipleAnswers === true) {
        outputFlowObject.newInputs = data;
      } else {
        outputFlowObject.newInputs = [data]; //newInput from QA is contained in data
      }
      outputFlowObject.flowState = this.originalFlowState;
      outputFlowObject.flowState.basket = this.$store.state.basketModule.basket; // include basket content in backend call
      outputFlowObject.executableSystemAction = this.executedSystemAction;
      outputFlowObject.meta = {
        uuid: this.$store.state.sessionModule.sessionID,
      }; // send uuid from Vuex Store to backend call
      outputFlowObject.flowStateHistory = this.flowStateHistory; // pass history information around

      evaluateAnswer(outputFlowObject).then((response) => {
        console.log(response);
        // hide loading modal whenever new response is coming
        this.loadingModal.visible = false;

        // keep original flow state data to be able to include in next request
        this.originalFlowState = response.flowState;
        this.executedSystemAction = response.executableSystemAction;
        this.meta = response.meta;
        this.flowStateHistory = response.flowStateHistory;
        this.productData = response.productData;

        // set session ID in Vuex based on meta data from server response
        this.$store.commit("setSessionID", response.meta.uuid);

        // check if basket from server needs to overwrite local basket (re-login case)
        if (response.meta.overwriteBasket === true) {
          for (let [id, v] of Object.entries(response.flowState.basket)) {
            this.$store.commit("addToBasket", {
              productId: id,
              productTitle: v.title,
              productImage: v.img,
            });
          }
        }

        // decide whether to update SingleCard Screen or MultiCard Screen
        this.screenToDisplay =
          SystemActionToScreenMapping[
            response.executableSystemAction.guiTemplate
          ];
        console.log(this.vm);
        try {
          this.$refs[this.screenToDisplay].updateQuestionAndResponse(
            response.executableSystemAction
          );
        } catch (error) {
          console.log(
            "Info about not-important error in updateQuestionAndResponse"
          );
          console.log(error);
        }

        // process guiActions if contained in executable system action
        if ("guiActions" in this.executedSystemAction) {
          this.processGUIActions(this.executedSystemAction.guiActions);
        }
      });
    },

    // used to process cards where multiple answers are submitted
    processMultipleAnswerInBackend(data) {
      this.processAnswerInBackend(data, true);
    },

    // update screen after DOM can be safely accessed
    updateScreen(singleOrMulti) {
      console.log("UPDATING");
      this.$refs[singleOrMulti].updateQuestionAndResponse(
        this.executedSystemAction
      );
    },

    processGUIActions(guiActionObj) {
      for (const [actionType, actionData] of Object.entries(guiActionObj)) {
        switch (actionType) {
          case "redirect":
            setTimeout(function () {
              window.location.href = actionData.path;
            }, actionData.timeoutSeconds * 1000);
        }
      }
    },

    reportBug() {
      this.bugreport = false;
      console.log(this.bugreportUserInput);
      let logs = {
        originalFlowState: this.originalFlowState,
        executedSystemAction: this.executedSystemAction,
      };

      console.log(logs);
      reportBugToBackend(this.bugreportUserInput, logs);
      this.bugreportUserInput = "";
    },

    showFeatureUnavailableModal(selectedTopic) {
      console.log(selectedTopic);
      this.selectedUnavailableFeature = selectedTopic;
      this.nonavailfeature = true;

      // record interest in backend
      recordInterestInTopic(this.meta.uuid, selectedTopic);
    },

    // show loading modal using data sent form sub-components
    showLoadingModal(loadingData) {
      this.loadingModal.header = loadingData.header;
      this.loadingModal.subtitle = loadingData.subtitle;
      this.loadingModal.visible = true;
    },

    subscribeToNewsletter() {
      addMailToNewsletter(
        this.newsletterEmail,
        this.selectedUnavailableFeature
      );
      this.nonavailfeature = false;
    },

    reportNewTopicModal() {
      this.reportnewtopic = true;
    },

    reportTopic() {
      this.reportnewtopic = false;
      reportNewTopicToBackend(this.newtopicUserInput);
      this.newtopicUserInput = "";
    },

    removeFromBasket(id) {
      const removeFromBasketPayload = {
        productId: id,
        force: true,
      };
      this.$store.commit("removeFromBasket", removeFromBasketPayload);
    },

    addToBasket(basketDataFromCard) {
      window.scrollTo(0, 0);
      this.drawer = true;
      this.$store.commit("addToBasket", basketDataFromCard);
    },
    // set mobile device bool on resize
    onResize() {
      this.isMobileDevice = window.innerWidth < 900;
    },

    // validateInput validates the text input given by the user (used to toggle the submit button)
    // sets the validationMessage and returns true/false whether the user input is valid or not
    // TODO: THIS IS A COPY OF THE SAME FUNCTION IN Customer Contact Detail => make global function
    isValidMail() {
      if (this.newsletterEmail.length === 0) {
        return false;
      }
      let re = new RegExp(
        "^[\\w!#$%&’*+/=?`{|}~^-]+(?:\\.[\\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$"
      );
      return re.test(this.$data.newsletterEmail) !== false;
    },
  },
  mounted() {
    // make sure window is scrolled to top at beginning
    window.scrollTo({ top: 0 });

    //event listener form header component.
    this.$root.$on("feedbackBtnClickonHeader", (visible) => {
      this.bugreport = visible;
    });
    // event listener for mobile detection
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    // check if flow needs to be launched for exclusive sani partner
    let flowInformation = {
      exclusiveSaniPartnerFlow: false,
    };

    // include customer ID if given als URL parameter
    if (this.$route.query.cID !== undefined) {
      flowInformation.sharedCustomerID = this.$route.query.cID;
    }

    // check if flow needs to be launch different dialog resources for exclusive sani partner
    if (this.$route.params.dialogName !== undefined) {
      flowInformation.customDialog = this.$route.params.dialogName;
    }

    this.$store.dispatch("recordInteraction", {
      eventType: "createConsultation",
      eventData: { flowInformation },
    });

    // initial call to backend
    console.log("APP is mounted, now making initial call to backend");

    this.processAnswerInBackend({
      initialCall: true,
      flowInformation,
    });
    this.loadInfoFromBackend();
  },
  beforeDestroy() {
    // remove event listener for resize before destroy
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  //Dynamic meta title and tags for Anni Beratung and Anni pflegegrad
  metaInfo() {
    return {
      title: this.$route.meta.title,
      meta: this.$route.meta.metaTags,
    };
  },
};
</script>
